import React, { useState, useEffect } from 'react'
import Menu from './scenes/Menu'
import Nav from './utils/Nav';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import Nzakara from './scenes/Nzakara';
import Badong from './scenes/Badong';
import Compas from './scenes/Compas';
import Sardaigne from './scenes/Sardaigne';
import Diphonique from './scenes/Diphonique';
import Madagascar from './scenes/Madagascar';
import Menu2 from './scenes/Menu2';
import Sardaigne_Intro from './scenes/SardaigneIntro';
import Sardaigne_Q1 from './scenes/SardaigneQ1';
import Sardaigne_Q2 from './scenes/SardaigneQ2';
import SardaigneMesere from './scenes/SardaigneMesere';
import SardaigneMesereB from './scenes/SardaigneMesereB';

export default function Player() {

  let audio = []

  return (
    <>
      <div className='background' />
      <BrowserRouter>
        <div>
          <Routes>
            <Route path={process.env.PUBLIC_URL + '/'} element={<Menu audio={audio} />} />
            <Route path={process.env.PUBLIC_URL + '/menu/'} element={<Menu2 audio={audio} />} />
            <Route path={process.env.PUBLIC_URL + '/nzakara/'} element={<Nzakara audio={audio} />} />
            <Route path={process.env.PUBLIC_URL + '/badong/'} element={<Badong audio={audio} />} />
            <Route path={process.env.PUBLIC_URL + '/flamenco/'} element={<Compas audio={audio} />} />
            <Route path={process.env.PUBLIC_URL + '/sardaigne/'} element={<Sardaigne audio={audio} />} />
            <Route path={process.env.PUBLIC_URL + '/diphonique/'} element={<Diphonique audio={audio} />} />
            <Route path={process.env.PUBLIC_URL + '/madagascar/'} element={<Madagascar audio={audio} />} />
            <Route path={process.env.PUBLIC_URL + '/madagascar/:page'} element={<Madagascar audio={audio} />} />
            <Route path={process.env.PUBLIC_URL + '/sardaigne/'} element={<Sardaigne_Intro audio={audio} />} />
            <Route path={process.env.PUBLIC_URL + '/sardaigne/partition/'} element={<Sardaigne_Q1 audio={audio} />} />
            <Route path={process.env.PUBLIC_URL + '/sardaigne/quintina/'} element={<Sardaigne_Q2 audio={audio} />} />
            <Route path={process.env.PUBLIC_URL + '/sardaigne/consonnes/'} element={<SardaigneMesere audio={audio} />} />
            <Route path={process.env.PUBLIC_URL + '/sardaigne/voyelles/'} element={<SardaigneMesereB audio={audio} />} />

            <Route path="*" element={<Navigate to={process.env.PUBLIC_URL + "/menu/"} replace />} />
          </Routes>
        </div >
      </BrowserRouter>
    </>
  )
}
